var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiperMobile"},[_c('div',{staticClass:"swiperHand"},[_c('img',{attrs:{"src":require("../assets/imgs/hand.svg"),"alt":""}})]),_c('div',{staticClass:"swiperContent"},[_c('img',{attrs:{"src":require("../assets/imgs/arrow_hand.svg"),"alt":""}}),_c('span',[_vm._v("Swipe to navigate the table")])])])
}]

export { render, staticRenderFns }